import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { VipDownline } from "../../modules/vipList/components/VipDownline";
import { VipList } from "../../modules/vipList/components/VipList";
import { VipReport } from "../../modules/vipList/components/VipReport";

const VipListContext = createContext();

const VipListWrapper = () => {
  const value = {};

  return (
    <VipListContext.Provider value={value}>
      <Routes>
        <Route path="" element={<VipList />} />
        <Route path=":memberid" element={<VipReport />} />
        <Route path="downline/:memberid/:username" element={<VipDownline />} />
      </Routes>
    </VipListContext.Provider>
  );
};

export { VipListWrapper };
